import React, { useEffect } from 'react';
import { useInterval, useRouter } from '../../../helpers/customHooks';

import Loader from '../../Shared/Loader';
import LiveBar from './LiveBar';
import MonthCalendar from './MonthCalendar';
import { routeToDate, routeToScheduleScope } from '../../../helpers';
import { LOAD_TODAY_EVENTS_TIME_SCHEDULE } from '../../../config/constants';
import { useEventsDispatch, useEventsState } from '../../../store/hooks/events';

import './MonthRows.scss';

const MonthRows = () => {
  
  const isMobile = window.matchMedia("only screen and (max-width: 900px)").matches;
  const { pathname } = useRouter();
  const pathOnlyDate = pathname.split('/').slice(0, 6).join('/');
  const events = useEventsState(pathname.split('/').slice(0, 6).join('/'));
  const { loadEvents } = useEventsDispatch();
  useInterval(loadEvents(false, true, undefined, undefined, isMobile), LOAD_TODAY_EVENTS_TIME_SCHEDULE);
  
  return (
    <>
      <div className="c-01">
        <Loader isMobile={isMobile} style={{ height: !isMobile ? 'calc(100vh - 198px)': 'calc(100vh - 186px)' }} />
        <MonthCalendar
          events={events}
          selectedDate={routeToDate(pathOnlyDate)}
        />
      </div>
      <LiveBar events={events} />
    </>
  );
};

export default MonthRows;
